import type { CaseDetail } from '../portfolio';

const aizuCoinCase: CaseDetail = {
  id: 'aizu-coin',
  project: 'AIZU COIN ブランドコミュニケーション戦略',
  client: 'Regional Community Organization',
  year: '2024',
  category: 'Brand Strategy / CX / Communication',
  role: 'Brand Strategy / CX Planning / Creative Direction',
  issue:
    '地域コミュニティとしての価値が生活者に伝わらず、参加意欲や利用率が低迷していた。機能・制度の説明だけでは、行動変容につながらない。',
  challenge:
    '機能的な説明を超え、生活者が「自分ごと」として関われる体験価値を再定義すること。',
  insight:
    'ツールではなく「コミュニティへの参加証」として捉え直すことで、関与の動機を変えられる。',
  strategy:
    'ブランドコンセプトを「つながりのインフラ」として再定義。行動データをCX改善サイクルに組み込む設計。',
  experience:
    '店舗・イベント・アプリを通じた統一体験。VIとメッセージの一貫性で接点全体をブランド化。',
  output: 'ブランドストーリー、VI、ウェブ、コミュニケーションプラン、イベント設計。',
  impact: '認知率向上、参加頻度の増加。地域コミュニティとの接点拡大。',
  images: [
    {
      src: '/assets/migrated/5754cdef7fa3a5937319.webp',
      caption: '表紙 — BRAND COMMUNICATION STRATEGY PLAN',
      large: true,
    },
    {
      src: '/assets/migrated/71e6fbcc14b9b3e13bd1.webp',
      caption: '企画書表紙 — TIS BRAND COMMUNICATION STRATEGY PLAN',
    },
    {
      src: '/assets/migrated/fc91f480829f1a9f28b4.webp',
      caption: 'はじめに — 会津コイン事業の価値を、未来につなぐために',
    },
    {
      src: '/assets/migrated/ee3a301ead79ae2b5a4f.webp',
      caption:
        'FINAL CHAPTER — 新しいブランドデザイン戦略で、会津コイン事業の未来を共創する',
    },
    {
      src: '/assets/migrated/25c61e2b076f09eef38d.webp',
      caption: 'INDEX — 目次 全体構成',
    },
    {
      src: '/assets/migrated/5ff60de8c41bf474681b.webp',
      caption:
        'INDEX — 会津コイン ブランド戦略企画書 & ブランドデザインガイドライン',
    },
    {
      src: '/assets/migrated/a02abfecf5525d6b71e2.webp',
      caption:
        'ワークショップ資料 — データと現場の声から会津コインの価値を最大化する戦略',
    },
    {
      src: '/assets/migrated/fcd090c9783b5b0c7ded.webp',
      caption:
        'ワークショップ資料詳細 — 4つの実践アプローチとマーケティングミックス検証',
    },
    {
      src: '/assets/migrated/cafde89febc86f85823b.webp',
      caption: 'ANALYSIS 00 — マーケティング・インサイト分析',
    },
    {
      src: '/assets/migrated/c96c10ad69ea3d61a42b.webp',
      caption:
        '分析から見えた結論と、これからの方向性 — SWOT分析とクロスSWOT戦略',
    },
    {
      src: '/assets/migrated/b0daf4b37c457982d184.webp',
      caption:
        'なぜ、今この戦略が必要なのか — 会津コインが直面する課題と目指すべき姿',
    },
    {
      src: '/assets/migrated/60aedd7a45cd55662f46.webp',
      caption:
        'ポジショニング分析 — 会津コインの独自領域を定義する「地域×公的信頼」の差別化軸',
    },
    {
      src: '/assets/migrated/262bc3c883fecd7bc33f.webp',
      caption:
        '4P×4C分析 — 地域と人がつながる価値創造戦略とクリエイティブ戦略の方向性',
    },
    {
      src: '/assets/migrated/f669f1b4e7cfc505e80d.webp',
      caption:
        'リーンキャンバス — ビジネスモデルの全体構造を一枚で把握する',
    },
    {
      src: '/assets/migrated/e70d4c15cec7f5aad11e.webp',
      caption:
        'バリュープロポジションキャンバス — 顧客が本当に求めているものと、会津コインが提供できるものを一致させる',
    },
    {
      src: '/assets/migrated/6b731355a9fa1f430dbb.webp',
      caption:
        'サービス要素分析 — 会津コインのサービスジャーニーと価値循環を可視化する',
    },
    {
      src: '/assets/migrated/b54789dcb52ed0cc53f0.webp',
      caption:
        '会津コイン 要素分解マップ — 商品特性の課題を可視化し、クリエイティブの切り口を設計',
    },
    {
      src: '/assets/migrated/1e0522b5cc70f92c25a7.webp',
      caption:
        'データと現場の声から、会津コインの価値を最大化する施策へ — 3つの戦略軸',
    },
    {
      src: '/assets/migrated/307af4d6997dc1147e89.webp',
      caption:
        'INSIGHT 01 | インサイト統合 — 分析が教えてくれた、たった一つの真実',
    },
    {
      src: '/assets/migrated/1f13140954c1cc7810fb.webp',
      caption:
        '会津コインの課題を解決し、地域の未来をつくるコミュニケーション設計',
    },
    {
      src: '/assets/migrated/b486d63f5e2e56ff04c2.webp',
      caption:
        '新たなコミュニケーションを再構築し、会津コインの価値をわかりやすく伝える設計図',
    },
    {
      src: '/assets/migrated/777bf2e42b0dc2102be1.webp',
      caption:
        'KEY INSIGHT — 分析から見えてきた5つの本質的なインサイト',
    },
    {
      src: '/assets/migrated/5689dcf8765c658e8a33.webp',
      caption:
        'タグライン — 会津コインの"核心的な一言"を設計する',
    },
    {
      src: '/assets/migrated/9ad04bae806cc6d8563a.webp',
      caption:
        'ブランドアイデア「使うたびに、会津が動く。」— タグライン候補 共通項による3方向の案',
    },
    {
      src: '/assets/migrated/b97e9725382b8ea19a9c.webp',
      caption:
        'キービジュアル デザイン方向性 — 案A/B/Cモチーフと4原則',
    },
    {
      src: '/assets/migrated/7b985fb169656b1133f1.webp',
      caption:
        'COPY — 3大訴求軸×コピー設計 ターゲット別"刺さる言葉"を設計する',
    },
    {
      src: '/assets/migrated/3f69650c842d03b2246b.webp',
      caption:
        '訴求軸① 納得感×コピー設計 — 事業者（加盟店）向け訴求',
    },
    {
      src: '/assets/migrated/745a315cbfa0315506ce.webp',
      caption:
        '訴求軸② 日常感×コピー設計 — 生活者（ユーザー）向け訴求',
    },
    {
      src: '/assets/migrated/1adb9d816454dcea85bf.webp',
      caption:
        '3大訴求軸×コピー設計まとめ — ターゲット別チャネルとコピー展開',
    },
    {
      src: '/assets/migrated/ffa3f9e27d03a43f2d48.webp',
      caption:
        'CHANNEL — チャンネル別コミュニケーションプラン AISASモデル×コンテンツ施策×KPI設計',
    },
    {
      src: '/assets/migrated/5d3529a5fded317d9526.webp',
      caption:
        'スライド39 — チャンネル別コミュニケーションプラン（続き）',
    },
    {
      src: '/assets/migrated/c674acf8e77d44953d75.webp',
      caption:
        '生活者との接点 — 会津コイン カスタマージャーニーマップ',
    },
    {
      src: '/assets/migrated/b8e0a188b814c932f636.webp',
      caption:
        '生活者との接点 — 会津コイン カスタマージャーニーマップ（詳細版）',
    },
    {
      src: '/assets/migrated/95887bff998f10e10bec.webp',
      caption:
        'CREATIVE — 会津コインの価値を伝え、地域の未来をつくるコミュニケーション設計へ（FEEL/LOOK/TALK/DO）',
    },
    {
      src: '/assets/migrated/eaa8fe972e6a20fb0c5f.webp',
      caption:
        'LOOKデザイン ガイドライン — 会津木綿の柄や質感を活かしたブランド一貫性',
    },
    {
      src: '/assets/migrated/8df58eefa58f0bd551d2.webp',
      caption:
        'LOOKデザイン ガイドライン詳細 — 3つのデザインベース（縞の力強さ/遊び心と融合/普遍の幾何学）',
    },
    {
      src: '/assets/migrated/f635c6e8b4b418f00d50.webp',
      caption:
        'ベコ 新キャラクターデザイン — 親しみやすく、丸みを帯びた地域に溶け込むベコ',
    },
    {
      src: '/assets/migrated/c70b4e8397155c75dd85.webp',
      caption:
        '会津コインが大切にする3つの価値 — TRADITION（伝統）/ GROWTH（成長）/ COMMUNITY（つながり）',
    },
    {
      src: '/assets/migrated/fffdb46346d9cdcc5ac1.webp',
      caption:
        '赤べこを再設計し、一貫したコミュニケーションを展開する — ブランドキャラクターとしての活用戦略',
    },
    {
      src: '/assets/migrated/cb0d2894e6e83be25c1c.webp',
      caption:
        'A方向案 — ベコ 新キャラクターデザイン（親しみやすく、丸みを帯びた地域に溶け込むベコ）',
    },
    {
      src: '/assets/migrated/4ff63e4e6477becb9ec9.webp',
      caption:
        'スライド54 — ベコ 新キャラクターデザイン（続き）',
    },
    {
      src: '/assets/migrated/4c4bc615ae0c32b58b43.webp',
      caption:
        'ベコ イラストモチーフ デザイン・パターン詳細 — パターンA/B/CのTRADITION/GROWTH/COMMUNITY表現',
    },
    {
      src: '/assets/migrated/20741c09e98141115c80.webp',
      caption:
        'ベコ イラストモチーフ デザイン・パターン-A — やさしく親しみやすい表現（TRADITION/GROWTH/COMMUNITY）',
    },
    {
      src: '/assets/migrated/4f35b91bb8d0e9912f48.webp',
      caption:
        'ベコ キャラクター デザインガイドライン — キャラクターの基本、使用ルール、使用シーン別ガイドライン、使用できる例・できない例',
    },
    {
      src: '/assets/migrated/0a53d493997ee16e3db9.webp',
      caption:
        '04-C 告知ポスターツール デザイン（章扉）',
    },
    {
      src: '/assets/migrated/393f616256127e4825ee.webp',
      caption:
        'COPY TO CREATIVE — コピー戦略から表現開発へ（訴求軸①納得感/②日常感/③共感）',
    },
    {
      src: '/assets/migrated/62daacf01f1496101998.webp',
      caption:
        '告知ポスターツールと店頭施策で、認知から利用へつなげる — 店頭での現行ツール展開例とツール展開の戦略',
    },
    {
      src: '/assets/migrated/ad580d11fc45dd69af61.webp',
      caption:
        '告知ポスターツール ベースデザイン — 3つのテーマで、会津コインの価値を伝える（TRADITION/GROWTH/COMMUNITY）',
    },
    {
      src: '/assets/migrated/missing-transparent.gif',
      caption:
        '会津コイン 告知ポスター・ツール ベースデザイン 別案 — 基本告知ポスター、人物入り告知ポスター、シンプルスタイリッシュバージョン、横断幕・POP・店頭ツール',
    },
    {
      src: '/assets/migrated/missing-transparent.gif',
      caption:
        '追加告知ポスター（2種）デザイン案 パラポスター — 2つのパラポスターデザイン',
    },
    {
      src: '/assets/migrated/missing-transparent.gif',
      caption:
        '会津コイン 告知ツール別案デザイン — A案（伝統×洗練）/ B案（モダン×温かみ）/ C案（シンプル×スタイリッシュ）',
    },
    {
      src: '/assets/migrated/1f2f98e7c271f9a5db0b.webp',
      caption:
        '04-D | のぼり タペストリーツール デザイン（章扉）',
    },
    {
      src: '/assets/migrated/a0ba9e1ab12ea082bd49.webp',
      caption:
        'のぼり タペストリーツール ベースデザイン（ベースデザインA・B）',
    },
    {
      src: '/assets/migrated/5809d3f584e83bcc9a4f.webp',
      caption:
        'のぼり タペストリーツール 現行ツールと横並びで掲出して展開する',
    },
    {
      src: '/assets/migrated/725ca7c8a420f25d7568.webp',
      caption:
        'のぼり タペストリーツール ベースデザイン（全3種と設置イメージ）',
    },
    {
      src: '/assets/migrated/d05256c2c03d4c376b26.webp',
      caption:
        'レジ横カウンターツール A案 ベースデザイン',
    },
    {
      src: '/assets/migrated/c4704e0685dea9b218d6.webp',
      caption:
        '購買ファネルを軸としたコミュニケーションプラン ターゲットインサイト',
    },
    {
      src: '/assets/migrated/ca6a7e16e182e8d549c8.webp',
      caption:
        '「会津コイン」店頭ツール・媒体一覧表',
    },
    {
      src: '/assets/migrated/e1ef582ca0d1919b9395.webp',
      caption:
        '04-E | レジ横 カウンターツール デザイン（章扉）',
    },
    {
      src: '/assets/migrated/436bad05f7a273afe448.webp',
      caption:
        'WEBサイト デザイン改修コンセプト 会津の魅力をわかりやすく',
    },
    {
      src: '/assets/migrated/f50cfce76d753690eaac.webp',
      caption:
        '04-F | WEBサイト - LPデザイン ベース表現（章扉）',
    },
    {
      src: '/assets/migrated/5994f030e2dafc177286.webp',
      caption:
        '会津コイン ウェブサイト・LPデザイン 改修コンセプト — 伝統とデジタルの融合で、地域の魅力と会津コインの価値をわかりやすく',
    },
    {
      src: '/assets/migrated/ce304ddd8ce79d204bf6.webp',
      caption:
        'データとデジタルバッジで、価値が伝わり、行動が生まれるLPデザインへ — Before/Afterと活用できるツール・機能',
    },
    {
      src: '/assets/migrated/d24c2c7aa57ab0c7f7ef.webp',
      caption:
        '04-G | SP - UIデザイン ベース表現（章扉）— LOOKデザイン×ブランドボイス×ビジュアルデザイン',
    },
    {
      src: '/assets/migrated/223ecadacb1f75adf638.webp',
      caption:
        'デザインバリエーション — 伝統の美しさを、今のライフスタイルに。4つのデザインで利用シーンに合わせた最適な体験を提供',
    },
    {
      src: '/assets/migrated/543a72422a3bba4570b7.webp',
      caption:
        'これからのUI/UXのあり方とデザインガイドライン — 使いやすさと美しさを両立し、地域の魅力を未来につなぐデザイン指針',
    },
    {
      src: '/assets/migrated/a443ee396cc2e02e9ba4.webp',
      caption:
        'SP-UIデザイン ベース表現まとめ — 伝統と信頼を、シンプルで使いやすい体験へ。4つのデザインバリエーションと5つのUX/UI方向性',
    },
    {
      src: '/assets/migrated/c43d226de9fc25c4ffd1.webp',
      caption:
        '05 | デジタルバッジ デザイン・プロモーション用（章扉）— デジタルバッジをデザイン設計して展開させプロモーションに活用する',
    },
    {
      src: '/assets/migrated/75dd03db070e07194ca1.webp',
      caption:
        'デジタルバッジで、会津ともっとつながる — 使う・参加する・体験するほどバッジが貯まり、ステージが上がり、特典が広がる新しい仕組み',
    },
    {
      src: '/assets/migrated/897ca74849b915b5488a.webp',
      caption:
        'デジタルバッジデザイン — 会津の誇りとつながりを、日常の中で輝かせるデジタルバッジ。限定エディションから四季デザインまで',
    },
    {
      src: '/assets/migrated/4cedb4f8e7ae544412c6.webp',
      caption:
        'デジタルバッジで、会津をもっと好きになる。もっと使いたくなる。 — バッジラインナップ、ステージと還元率、特典・体験の全体設計',
    },
    {
      src: '/assets/migrated/75f27fac8b51cec8e8be.webp',
      caption:
        '現状のマイレージクラブからデジタルバッジへ進化 — 行動・参加・体験をバッジで可視化し、会津とのつながりを深める仕組み',
    },
    {
      src: '/assets/migrated/9d831c9f0131e8932a41.webp',
      caption:
        '会津コイン デジタルバッジ NFTデザイン&証明設計 — WEB3/NFTで価値を証明し、唯一性と信頼性を担保するデジタルバッジ',
    },
    {
      src: '/assets/migrated/8dea9a4d7f8d6fa610c5.webp',
      caption:
        '06 | プロモーション施策 企画案（章扉）— プロモーション施策のアクションで企画踏襲でFAN層をさらに拡大',
    },
    {
      src: '/assets/migrated/220c44dc0c45dba3dcef.webp',
      caption:
        '会津コイン プロモーション施策 企画案8選 — デジタルとリアルを融合し、会津の魅力を「体験」しながら広げる8つのプロモーション施策',
    },
    {
      src: '/assets/migrated/0eff31d269f9142f2a3c.webp',
      caption:
        '施策01 赤べこスタンプラリー — 会津のまちを巡って、バッジを集めよう！',
    },
    {
      src: '/assets/migrated/a4088b8c2d5f404fe0da.webp',
      caption:
        '施策02 会津四季ミッション — 四季の魅力を楽しみながら、バッジを集めてつなげよう！',
    },
    {
      src: '/assets/migrated/af0570fc2ad517e5f8d2.webp',
      caption:
        '施策03 加盟店グランプリ — みんなで選ぶ、お気に入りのお店を応援しよう！',
    },
    {
      src: '/assets/migrated/38113197f078bddeec4b.webp',
      caption:
        '施策04 会津コイン×即時インセンティブ — その場でお得、つかうほど嬉しいプロモーション',
    },
    {
      src: '/assets/migrated/9806a10e7a3c76d2862c.webp',
      caption:
        '施策07 会津コイン パートナーシッププログラム — 地域の「つながり」を可視化し、お得と信頼を広げる新しい関係づくり',
    },
    {
      src: '/assets/migrated/3ce83a540e31b15e9894.webp',
      caption:
        'スライド108 — プロモーション施策（続き）',
    },
    {
      src: '/assets/migrated/3e15acd9b55ac6811da5.webp',
      caption:
        '07 | これからのクリエイティブ実行 ロードマップ（章扉）',
    },
    {
      src: '/assets/migrated/404cecc6e5c5fc04d2f7.webp',
      caption:
        'BRAND ROADMAP PHASE 01-02 — ブランド基盤の構築と体験価値の設計',
    },
    {
      src: '/assets/migrated/c789c9548ef1cdcfd221.webp',
      caption:
        'BRAND ROADMAP PHASE 03-04 — コミュニケーションの拡大とブランドの拡張',
    },
    {
      src: '/assets/migrated/bf844b46d794d6e2d3e2.webp',
      caption:
        'BRAND ROADMAP PHASE 05 — FUTURE VISION 会津の未来をつくる、地域ブランドプラットフォームへ',
    },
    {
      src: '/assets/migrated/669435ff538703ef9fbc.webp',
      caption:
        'ブランドコミュニケーション展開ツール一覧 — 店頭・デジタル・SNS・キャンペーンの全ツールとBefore→After',
    },
    {
      src: '/assets/migrated/20b37fed77b05b439062.webp',
      caption:
        'ブランドコミュニケーションマップ — 利用者の体験ジャーニーに沿った最適なコミュニケーション設計',
    },
    {
      src: '/assets/migrated/169cb6b2f4d62585c75b.webp',
      caption:
        'ブランドコミュニケーション監査・設計フロー 詳細拡大 — 現状の媒体洗い出しからマップ配置、役割・機能検証まで',
    },
    {
      src: '/assets/migrated/61adbb8cc54fadb572c9.webp',
      caption:
        'NEXT STEP — 価値を見つけ、伝え方を変える。その積み重ねが、ブランドを育てていく。',
    },
    {
      src: '/assets/migrated/bd2a5796a1abcdbefd1a.webp',
      caption:
        'おわりに。NEXT STEP — 次のステージへ。価値を見つけ、伝え方を変える。その積み重ねが、ブランドを育てていく。',
    },
    {
      src: '/assets/migrated/62df54cfd90f40af244e.jpg',
      caption: '裏表紙 — BRAND COMMUNICATION STRATEGY PLAN',
    },
  ],
};

export default aizuCoinCase;